import { render, staticRenderFns } from "./FeaturedProgram.vue?vue&type=template&id=6636a8bf&"
import script from "./FeaturedProgram.vue?vue&type=script&lang=js&"
export * from "./FeaturedProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports